module.exports = __webpack_public_path__ + "media/img/pages/companies/rolex-e4ab7874b7028f1bad338f7b0476ee9c.png";